import type {ColumnFragment, ColumnRefOptionsFragment, ValueInstanceFragment} from "app/gql/graphqlSchema";
import {DisplayValue} from "app/employee/controlCard/DisplayValue";

interface Props {
  column: ColumnFragment;
  valueInstance: ValueInstanceFragment;
  columnRefOptions: ColumnRefOptionsFragment[];
}

export const DisplayValueInstance = ({valueInstance, column, columnRefOptions}: Props) => {
  return <DisplayValue column={column} columnRefOptions={columnRefOptions} value={valueInstance.value} />;
};
